import { useEffect, useState } from "react";

import { useMasterLookupsApi } from "../../../../../../common/api/master-api/lookups/useMasterLookupsApi";
import { CourseOfActionReference } from "../../../../../../common/types/CourseOfActionReference";
import { FixedBillingReference } from "../../../../../../common/types/FixedBillingReferfence";

export const useCourseOfActionFormFieldsValues = () => {
    const [courseOfActions, setCourseOfActions] = useState<CourseOfActionReference[]>([]);
    const [fixedBillings, setFixedBillings] = useState<FixedBillingReference[]>([]);

    const [areCourseOfActionsLoading, setAreCourseOfActionsLoading] = useState(false);
    const [areFixedBillingsLoading, setAreFixedBillingsLoading] = useState(false);

    const { getCourseOfActions, getFixedBillings } = useMasterLookupsApi();

    useEffect(() => {
        setAreCourseOfActionsLoading(true);
        getCourseOfActions()
            .then(({ items }) => setCourseOfActions(items))
            .finally(() => setAreCourseOfActionsLoading(false));
    }, []);

    useEffect(() => {
        setAreFixedBillingsLoading(true);
        getFixedBillings()
            .then(({ items }) => setFixedBillings(items))
            .finally(() => setAreFixedBillingsLoading(false));
    }, []);

    return {
        courseOfActions,
        areCourseOfActionsLoading,
        fixedBillings,
        areFixedBillingsLoading
    };
};
